import React from 'react';
import {
  Button,
  Container,
  Grid,
  makeStyles,
  SvgIcon,
  Typography,
} from '@material-ui/core';
import {Stack} from '@mui/material';

import function1 from 'assets/images/svg/func/send.svg';
import function2 from 'assets/images/svg/func/security.svg';
import function3 from 'assets/images/svg/func/stake.svg';
import function4 from 'assets/images/svg/func/simplicity.svg';
import function5 from 'assets/images/svg/func/walletconnect.svg';
import function6 from 'assets/images/svg/func/clock-two.svg';
import shinobiApp from 'assets/images/home/shinobi-app.png';

import {useTranslation} from 'react-i18next';
import {useHistory} from 'react-router';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import iosStore from 'assets/images/apple.png';
import googleStore from 'assets/images/google.png';
import PartnerShip from './Partnership';
import {Text} from 'App';
import {useMatchesSize} from 'common/useMatchesSize';
import AliceCarousel from 'react-alice-carousel';
import {RoundedButton} from 'components';

export default function FunctionApp() {
  const classes = useStyles();
  const history = useHistory();
  const {t} = useTranslation();

  const {isSmall} = useMatchesSize();
  const handleScrollTop = () => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  };
  const data = [
    {
      image: function1,
      viewBox: '0 0 28 28',
      title: t('homepage.function.title1'),
      description: t('homepage.function.description1'),
    },
    {
      image: function2,
      viewBox: '0 0 32 32',
      title: t('homepage.function.title2'),
      description: t('homepage.function.description2'),
    },
    {
      image: function3,
      viewBox: '0 0 32 32',
      title: t('homepage.function.title3'),
      description: t('homepage.function.description3'),
    },
    {
      image: function4,
      viewBox: '0 0 32 32',
      title: t('homepage.function.title4'),
      description: t('homepage.function.description4'),
    },
    {
      image: function5,
      viewBox: '0 0 32 32',
      title: t('homepage.function.title5'),
      description: t('homepage.function.description5'),
    },
    {
      image: function6,
      viewBox: '0 0 32 32',
      title: t('homepage.function.title6'),
      description: t('homepage.function.description6'),
    },
  ];

  const items = data.map((item) => (
    <Grid item xs={12} className={classes.imageIcon} key={item.title}>
      <SvgIcon component={item.image} viewBox={item.viewBox} />
      <Text variant="titleFunction">{item.title}</Text>
      <Typography className={classes.textDes}>{item.description}</Typography>
    </Grid>
  ));
  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item md={5} sm={12} xs={12} className={classes.shinobiApp}>
          <img src={shinobiApp} className={classes.shinobiImg} />
        </Grid>
        <Grid
          container
          item
          md={7}
          sm={12}
          xs={12}
          className={classes.nativeApp}>
          <Grid item xs={12}>
            <Typography className={classes.title}>
              {t('homepage.function.title')}
            </Typography>
            <Typography variant="h5" className={classes.desNative}>
              {t('homepage.function.description')}
            </Typography>
          </Grid>
          {data.map((item) => (
            <Grid
              item
              md={6}
              sm={6}
              xs={11}
              className={classes.imageIcon}
              key={item.title}>
              <img src={item.image} style={{height: 30}} />
              <Text variant="titleFunction">{item.title}</Text>
              <Typography className={classes.textDes}>
                {item.description}
              </Typography>
            </Grid>
          ))}
          {/* {isSmall && (
            <AliceCarousel disableButtonsControls items={items} mouseTracking />
          )} */}
          <Stack alignItems="center" sx={{width: '100%', marginTop: 3}}>
            <RoundedButton
              variant="contained"
              hasIcon
              onClick={handleScrollTop}>
              {t('homepage.function.download')}
            </RoundedButton>
          </Stack>
        </Grid>
      </Grid>
    </div>
  );
}
const useStyles = makeStyles((theme) => ({
  root: {},
  methodImg: {
    maxWidth: '70%',
    margin: '0 auto',
  },
  shinobiImg: {
    width: '100%',
  },

  shinobiImg2: {
    maxWidth: '60%',
    marginBottom: 30,
  },
  nativeApp: {
    paddingLeft: '5%',
    paddingRight: '10%',
    paddingBottom: 80,
    backgroundColor: '#FFF8F2',
    [theme.breakpoints.down('sm')]: {
      // paddingLeft: 0,
      justifyContent: 'center',
      padding: '0 50px',
      paddingBottom: 80,
    },
    [theme.breakpoints.down('xs')]: {
      // paddingLeft: 0,
      justifyContent: 'center',
      padding: '0 10px',
      paddingBottom: 80,
    },
  },
  title: {
    color: '#463A6D',
    fontWeight: 700,
    marginBottom: 16,
    marginTop: 80,
    fontSize: 33,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
      width: '100%',
      fontSize: 30,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 24,
      textAlign: 'left',
      width: '100%',
      padding: '0 20px',
    },
  },
  btnApps: {
    display: 'flex',
    marginTop: 20,
  },
  shinobiApp: {
    backgroundColor: '#FF7C7C',
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  divBtnApp1: {
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      textAlign: 'right',
    },
  },
  divBtnApp2: {
    [theme.breakpoints.down('sm')]: {
      width: '50%',
      textAlign: 'left',
    },
  },
  desNative: {
    marginBottom: 32,
    fontSize: 22,
    [theme.breakpoints.down('sm')]: {
      textAlign: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
      padding: '0 20px',
      fontSize: 14,
    },
  },
  imageIcon: {
    textAlign: 'left',
    marginTop: 50,
    [theme.breakpoints.down('sm')]: {
      // textAlign: 'center',
      paddingLeft: 16,
    },
  },
  textDes: {
    color: '#999999',
    fontSize: '1.2vw',
    // padding: '0 16px',
    paddingRight: 16,
    marginTop: 10,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.8vw',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
      marginBottom: 30,
    },
  },
}));
